import React, { useState, useEffect, useRef } from 'react';
import { CheckToken } from '../login/AccessToken';
import axios from 'axios';
import './BillingPayment.scss';
import './StagingArea.scss';
import { useHistory } from 'react-router-dom';
import { Button, Accordion, AccordionSummary, AccordionDetails, Typography, Select, MenuItem, FormControl, Autocomplete, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { displayPatientName } from '../../utils/displayPatientName';

// Minimum typed characters before patient search API is called
const PATIENT_SEARCH_MIN_LENGTH = 2;
// Delay between keystrokes before triggering patient search
const PATIENT_SEARCH_DEBOUNCE_MS = 500;

const StagingArea = ({ pathname }) => {
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [authToken, setAuthToken] = useState('');
  const [aabhaId, setAabhaId] = useState('');




  const [selectedPatientId, setSelectedPatientId] = useState('');
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientList, setPatientList] = useState([]);
  const [patientSearchError, setPatientSearchError] = useState('');
  const [careContexts, setCareContexts] = useState([]);
  const [selectedCareContext, setSelectedCareContext] = useState('');
  const [fhirData, setFhirData] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState('');
  const [facilityList, setFacilityList] = useState([]);
  const [doctorNames, setDoctorNames] = useState([]);
  const [serviceRequests, setServiceRequests] = useState([]);
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [selectedServiceRequests, setSelectedServiceRequests] = useState([]);
  const [labTests, setLabTests] = useState([]);
  const [medicinesList, setMedicinesList] = useState([]);
  // Debounce timer and abort controller for in-flight patient search requests
  const patientSearchDebounceRef = useRef(null);
  const patientSearchAbortRef = useRef(null);
  const history = useHistory();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const handleDoctorCheckboxChange = (doctorName) => {
    if (selectedDoctors.includes(doctorName)) {
      setSelectedDoctors(selectedDoctors.filter((name) => name !== doctorName));
    } else {
      setSelectedDoctors([...selectedDoctors, doctorName]);
    }
  };

  // const handleServiceRequestCheckboxChange = (serviceRequestId) => {
  //   if (selectedServiceRequests.includes(serviceRequestId)) {
  //     setSelectedServiceRequests(selectedServiceRequests.filter((id) => id !== serviceRequestId));
  //   } else {
  //     setSelectedServiceRequests([...selectedServiceRequests, serviceRequestId]);
  //   }
  // };
  const handleServiceRequestCheckboxChange = (serviceRequestCode) => {
    const key = String(serviceRequestCode);
    if (selectedServiceRequests.includes(key)) {
      setSelectedServiceRequests(
        selectedServiceRequests.filter((lab_test_id) => lab_test_id !== key),
      );
    } else {
      setSelectedServiceRequests([...selectedServiceRequests, key]);
    }
  };
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);


  useEffect(() => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem('accessToken') ?? '');
  }, []);

  // Facility list fetch disabled for now — facility dropdown is temporarily hidden
  // useEffect(() => {
  //   fetchFacilityListFromClient();
  // }, [authToken]);

  // Patient list is no longer loaded on page load or facility change; search triggers fetch instead
  // useEffect(() => {
  //   if (selectedFacility) {
  //     fetchPatientList();
  //   }
  // }, [selectedFacility]);

  // Clear debounce timer and abort any pending search on unmount
  useEffect(() => {
    return () => {
      if (patientSearchDebounceRef.current) {
        clearTimeout(patientSearchDebounceRef.current);
      }
      if (patientSearchAbortRef.current) {
        patientSearchAbortRef.current.abort();
      }
    };
  }, []);

  // useEffect(() => {
  //   if (aabhaId) {
  //     fetchCareContexts();
  //   }
  // }, [aabhaId]);

  // useEffect(() => {
  //   if (selectedCareContext) {
  //     fetchFhirData();
  //   }
  // }, [selectedCareContext]);
  console.log("serviceRequests", serviceRequests)
  // Facility list API disabled for now — re-enable when facility dropdown is shown again
  // const fetchFacilityListFromClient = () => {
  //   if (authToken !== "") {
  //     axios.post(`${REACT_APP_BACKEND_ROUTE_URL}get_all_facility_list_from_client/`, null, {
  //       headers: { Authorization: `Bearer ${authToken}` },
  //     })
  //       .then((res) => {
  //         const list = res.data.facility_list || [];
  //         setFacilityList(list);
  //         if (list.length === 1) {
  //           setSelectedFacility(list[0].facility_id);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error fetching facility list from client:', error);
  //       });
  //   }
  // };

  /**
   * Fetch patients matching the search query.
   * Uses get_patient_list_with_aabha_info instead of facility-based patient list.
   * Not called on page load — only after debounced user input (min 2 characters).
   */
  const fetchPatientList = (searchQuery) => {
    if (authToken === '') {
      return;
    }

    if (patientSearchAbortRef.current) {
      patientSearchAbortRef.current.abort();
    }

    const abortController = new AbortController();
    patientSearchAbortRef.current = abortController;

    setPatientSearchError('');

    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`, {
        headers,
        params: { search: searchQuery },
        signal: abortController.signal,
      })
      .then((res) => {
        if (abortController.signal.aborted) {
          return;
        }
        // Response shape matches previous facility-based endpoint (patient_list)
        const list = res.data?.patient_list || res.data?.data || [];
        setPatientList(list);
      })
      .catch((error) => {
        if (axios.isCancel(error) || error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
          return;
        }
        console.error('Error fetching patient list:', error);
        setPatientSearchError('Failed to load patients. Please try again.');
        setPatientList([]);
      });
  };

  /**
   * Handle Autocomplete input changes: debounce API calls and enforce minimum search length.
   * Skips fetch on programmatic input updates (e.g. when a patient is selected).
   */
  const handlePatientSearchInputChange = (event, newInputValue, reason) => {
    if (reason === 'reset') {
      return;
    }

    if (patientSearchDebounceRef.current) {
      clearTimeout(patientSearchDebounceRef.current);
      patientSearchDebounceRef.current = null;
    }

    const trimmedSearch = (newInputValue || '').trim();

    if (trimmedSearch.length < PATIENT_SEARCH_MIN_LENGTH) {
      if (patientSearchAbortRef.current) {
        patientSearchAbortRef.current.abort();
        patientSearchAbortRef.current = null;
      }
      setPatientSearchError('');
      setPatientList([]);
      return;
    }

    patientSearchDebounceRef.current = setTimeout(() => {
      fetchPatientList(trimmedSearch);
    }, PATIENT_SEARCH_DEBOUNCE_MS);
  };

  function fetchLabTests(patientId) {
    const requestData = {
      patient_id: patientId
    };
    axios.post(
      `${REACT_APP_BACKEND_ROUTE_URL}get_specific_patient_lab_tests/`, requestData,
      { headers: headers }
    )
      .then((response) => {

        setLabTests(response.data.lab_test_list);
      })
      .catch((error) => {
        console.log('FETCH FAILED:', error);
      });
  }
  function fetchMedicines(patientId) {
    const requestData = {
      patient_id: patientId
    };
    axios.post(
      `${REACT_APP_BACKEND_ROUTE_URL}get_specific_patient_medicines/`, requestData,
      { headers: headers }
    )
      .then((response) => {

        setMedicinesList(response.data.medicine_list);
      })
      .catch((error) => {
        console.log('FETCH FAILED:', error);
      });
  }

  const handlePatientSelectChange = (event, newValue) => {
    const selectedPatientId = newValue ? newValue.patient_id : '';
    const selectedAabhaId = newValue ? newValue.abha_id : '';

    setSelectedPatient(newValue);
    setSelectedPatientId(selectedPatientId);
    setAabhaId(selectedAabhaId);
    if (selectedPatientId) {
      fetchLabTests(selectedPatientId);
      fetchMedicines(selectedPatientId);
    } else {
      setLabTests([]);
      setMedicinesList([]);
    }
  };

  const handleAddToInvoice = () => {
    const selectedLabTests = labTests.filter((test) =>
      selectedServiceRequests.includes(String(test.lab_test_id)),
    );
    const medical_service_ids = selectedLabTests
      .map((test) => test.medical_service_id)
      .filter((id) => id !== undefined && id !== null && id !== "");

    console.log("Adding selected items to the invoice:", selectedDoctors, selectedServiceRequests, "aabhaId:", aabhaId);
    console.log('Selected Medical Service IDs:', medical_service_ids);

    const newPathname = pathname || '/newEstimate';

    history.push({
      pathname: newPathname,
      state: {
        selectedDoctors,
        selectedServiceRequests,
        aabhaId,
        selectedPatientId,
        medical_service_ids,
        source: 'populated',
      },
    });
  };

  const buttonText = pathname && pathname.includes("/newInvoice") ? "Add to Invoice" : "Add to Estimate";

  return (
    <div className="staging-area">
      {/* Header bar mirroring Image 2 */}
      <div className="staging-area__header">
        <h2 className="staging-area__title">Staging Area</h2>
      </div>

      <div className="staging-area__content">
        <div className="contact-panel">
          <form className="contact-panel__form" >
            <div className="row">
              {/* Facility dropdown hidden for now — re-enable when facility selection is needed again */}
              <div className="col-12" style={{ display: 'none' }}>
                <div className="form-group">
                  <label className="input-label" htmlFor="facilitySelect">Select Facility:</label>
                  <FormControl fullWidth size="small">
                    <Select
                      id="facilitySelect"
                      name="facilitySelect"
                      value={selectedFacility || ''}
                      onChange={(e) => setSelectedFacility(e.target.value)}
                      displayEmpty
                      sx={{
                        backgroundColor: '#fff',
                        borderRadius: '6px',
                        height: '44px',
                        '& .MuiSelect-select': {
                          padding: '10px 12px',
                          fontSize: '0.9rem',
                          color: '#172935',
                          fontFamily: '"Roboto", sans-serif',
                          display: 'flex',
                          alignItems: 'center',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#d1d9e6',
                          borderWidth: '1.5px',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#1a2d5e',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#1a2d5e',
                          borderWidth: '1.5px',
                        }
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            '& .MuiMenuItem-root.Mui-selected': {
                              backgroundColor: '#1a2d5e !important',
                              color: '#fff',
                            },
                            '& .MuiMenuItem-root.Mui-selected:hover': {
                              backgroundColor: '#0e1a3d !important',
                            },
                            '& .MuiMenuItem-root:hover': {
                              backgroundColor: 'rgba(26, 45, 94, 0.1)',
                            }
                          }
                        }
                      }}
                    >
                      {facilityList.length > 1 && <MenuItem value="" disabled>Select a facility</MenuItem>}
                      {facilityList.map((facility) => (
                        <MenuItem key={facility.facility_id} value={facility.facility_id}>
                          {`${facility.facility_id} - ${facility.facility_name}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group">
                  <label className="input-label" htmlFor="patientSelect">Select Patient:</label>
                  <FormControl fullWidth size="small">
                    <Autocomplete
                      id="patientSelect"
                      options={patientList}
                      getOptionLabel={(option) =>
                        `${option.patient_id} - ${displayPatientName(option.name)} - ${option.age} Yr`
                      }
                      value={selectedPatient}
                      onChange={handlePatientSelectChange}
                      onInputChange={handlePatientSearchInputChange}
                      filterOptions={(options) => options}
                      noOptionsText={
                        patientSearchError ||
                        'Type at least 2 characters to search patients'
                      }
                      isOptionEqualToValue={(option, value) => option.patient_id === value.patient_id}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search a patient by name, ID, or phone number"
                          error={Boolean(patientSearchError)}
                          helperText={patientSearchError || ''}
                          sx={{
                            backgroundColor: '#fff',
                            '& .MuiOutlinedInput-root': {
                              height: '44px',
                              borderRadius: '6px',
                              '& fieldset': {
                                borderColor: '#d1d9e6',
                                borderWidth: '1.5px',
                              },
                              '&:hover fieldset': {
                                borderColor: '#1a2d5e',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#1a2d5e',
                                borderWidth: '1.5px',
                              },
                            },
                            '& .MuiInputBase-input': {
                              fontSize: '0.9rem',
                              color: '#172935',
                              fontFamily: '"Roboto", sans-serif',
                            }
                          }}
                        />
                      )}
                      PaperProps={{
                        sx: {
                          maxHeight: 250,
                          backgroundColor: '#fff',
                          '& .MuiAutocomplete-option[aria-selected="true"]': {
                            backgroundColor: '#1a2d5e !important',
                            color: '#fff',
                          },
                          '& .MuiAutocomplete-option[data-focus="true"]': {
                            backgroundColor: 'rgba(26, 45, 94, 0.1)',
                          },
                          '& .MuiAutocomplete-option:hover': {
                            backgroundColor: 'rgba(26, 45, 94, 0.1)',
                          }
                        }
                      }}
                    />
                  </FormControl>
                </div>
              </div>
            </div>
          </form>

          <h5>Tests And Examinations to be Included:</h5>
          <div className="contact-panel mb-30 scrollable-container">
            {Object.keys(labTests.reduce((acc, test) => {
              const careContextId = test.care_context_id || 'No Care Context';
              if (!acc[careContextId]) acc[careContextId] = [];
              acc[careContextId].push(test);
              return acc;
            }, {})).map((careContextId, index) => {
              const testsInContext = labTests.filter(t => (t.care_context_id || 'No Care Context') === careContextId);
              const firstTestDate = testsInContext.length > 0 ? new Date(testsInContext[0].appointment_start_time).toLocaleDateString() : '';

              return (
                <Accordion
                  key={careContextId}
                  square
                  sx={{
                    boxShadow: 'none',
                    borderBottom: '1px solid #e0e0e0',
                    width: '100%',
                    '&:before': { display: 'none' }
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      backgroundColor: '#e0e0e0', // Gray background like Image 2
                      minHeight: '40px !important',
                      '& .MuiAccordionSummary-content': { margin: '8px 0 !important' }
                    }}
                  >
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 500, color: '#333' }}>
                      {careContextId} - {firstTestDate}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: '0', display: 'flex', flexDirection: 'column', gap: '0' }}>
                    {testsInContext.map((serviceRequest) => (
                      <div key={serviceRequest.lab_test_id} className="test-item-row">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`test-check-${serviceRequest.lab_test_id}`}
                          value={serviceRequest.lab_test_id}
                          checked={selectedServiceRequests.includes(
                            String(serviceRequest.lab_test_id),
                          )}
                          onChange={() =>
                            handleServiceRequestCheckboxChange(
                              serviceRequest.lab_test_id,
                            )
                          }
                        />
                        <label htmlFor={`test-check-${serviceRequest.lab_test_id}`} className="test-label">
                          {`${serviceRequest.test_name} - ${new Date(serviceRequest.appointment_start_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`}
                        </label>
                      </div>
                    ))}
                  </AccordionDetails>
                </Accordion>
              );
            })}
            {labTests.length === 0 && <div style={{ padding: '20px', color: '#888', fontStyle: 'italic', textAlign: 'center' }}>No tests available</div>}
          </div>

          <h5>Medicines to be Included:</h5>
          <div className="contact-panel mb-50 scrollable-container">
            {medicinesList.map((medicine) => (
              <div key={medicine.snomed_code} className="medicine-item-row">
                <label className="medicine-label">{` ${medicine.medicine_name} - ${new Date(medicine.appointment_start_time).toLocaleString()}`}</label>
              </div>
            ))}
            {medicinesList.length === 0 && <div className="no-data">No medicines available</div>}
          </div>

          <div className="button-container">
            <Button
              onClick={handleAddToInvoice}
              disabled={selectedDoctors.length === 0 && selectedServiceRequests.length === 0}
              variant="contained"
              sx={{
                backgroundColor: "#1a2d5e", // Dark blue from Image 2
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "700",
                paddingX: 5,
                paddingY: 1.5,
                textTransform: "uppercase",
                width: "90%",
                "&:hover": {
                  backgroundColor: "#0e1a3d",
                },
                "&:disabled": {
                  backgroundColor: "#d1d9e6",
                  color: "#8898aa"
                }
              }}
            >
              + {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StagingArea;
